import { render, staticRenderFns } from "./PhoneBooksList.vue?vue&type=template&id=87db1100&scoped=true&"
import script from "./PhoneBooksList.vue?vue&type=script&lang=js&"
export * from "./PhoneBooksList.vue?vue&type=script&lang=js&"
import style0 from "./PhoneBooksList.vue?vue&type=style&index=0&id=87db1100&lang=scss&scoped=true&"
import style1 from "./PhoneBooksList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87db1100",
  null
  
)

export default component.exports